<template>
  <div>
    <div class="top-warp">
      <div class="header">
          <div class="title">
              {{tabTitle}}
          </div>
          <div class="title-bottom">
              <div class="bottom-sidebar"></div>
          </div>
      </div>
      <!-- <div class="grid-content topheader">
        <img class="logo1" src="../../static/images/logo1.png" alt="">
        <div class="title">孕遇数据管理</div>
        <div class="time">今天是{{newDate}}</div>
      </div> -->
      <!-- <div class="header-nav">
        <ul class="clearfix">
          <li v-for="(item,index) in datas" :key="index" @click="changeBg(index)" :class="{libg: index == curIndex}">
            <router-link :to="item.route">
              <div class="pr navli">
                <i class="pa" :class="[item.class]"></i>
                <p>{{item.title}}</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>
<script>
  export default{
    name:"NavHeader",
    data(){
      return {
        tabTitle:'',
        newDate:'',
        datas:[
          {
            title:'商品数据',
            class: 'icon-a1',
            route:'/marketing'
          },
          {
            title:'服务数据',
            class: 'icon-a2',
            route:'/order'
          },
          {
            title:'入驻商户数据',
            class: 'icon-a3',
            route:'/emergencyManage'
          },
          {
            title:'护理统计',
            class: 'icon-a4',
            route:'/touristComplaint'
          },
          {
            title:'护理房间统计',
            class: 'icon-a5',
            route:'/nursingRoom'
          },
          {
            title:'用户量统计',
            class: 'icon-a6',
            route:'/userStatistics'
          },
          {
            title:'财务统计',
            class: 'icon-a7',
            route:'/finance'
          },
          {
            title:'供应商数据',
            class: 'icon-a8',
            route:'/supplier'
          }
        ],
        curIndex:0
      }
    },
    mounted() {
      let that = this
      console.log(that.$route.path)
      switch(that.$route.path){
        case '/':that.tabTitle = '商品及销量总览'
        break;
        case '/marketing':that.tabTitle = '商品及销量总览'
        break;
        case '/order':that.tabTitle = '服务及销量总览'
        break;
        case '/emergencyManage':that.tabTitle = '商户入驻数据'
        break;
      }
      that.getDate()
    },
    methods:{
      getDate(){
        let that = this;
        let date = new Date(),yearDate=null,monthDate=null,dayDate=null;
        yearDate = date.getFullYear()
        monthDate = date.getMonth()+1
        dayDate = date.getDate()
        monthDate = monthDate<10?'0'+monthDate:monthDate
        dayDate = dayDate<10?'0'+dayDate:dayDate
        that.newDate = yearDate+'年'+monthDate+'月'+dayDate+'日'
      },
      changeBg(index){
        this.curIndex = index;
      }
    }
  }
</script>
<style scoped>
  .header {
      /* margin: 4px; */
      height: 10vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }

  .header .title {
      font-size: 0.4rem;
      color: #fff;
      text-align: center;

  }

  .title-bottom {
      height: 30px;
      justify-content: center;
      display: flex;
      margin-top: 5px;
  }

  .bottom-sidebar {
      width: 100%;
      height: 100%;
      opacity: 1;
      background-image: url("~@/assets/images/bottombar.gif");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      width: 400px;
  }
  .topheader{height: 1rem; line-height: 1rem;width: 100%;background-image: linear-gradient(top, #3b72ee, #012352);background-image: -o-linear-gradient(top, #3b72ee, #012352);
    background-image: -moz-linear-gradient(top, #3b72ee, #012352);
    background-image: -webkit-linear-gradient(top, #3b72ee, #012352);
  }
  .logo1{width: 1.4rem;float: left;margin-top: .32rem;padding-left: .5rem;}
  .time{font-size: .16rem;color: #fff;float: right;padding-right: .5rem;}
  .header-nav{width:100%;height:.96rem;overflow: hidden}
  .header-nav ul li{width:12.5%;background: #3b72ee; float: left; height: .94rem;cursor: pointer;border-bottom: solid 1px #012352;border-top: solid 1px #012352}
  .header-nav .navli{border-left: solid 2px #012352;height: .94rem;text-align: center}
  .header-nav .navli p{padding-top:.58rem;text-align: center; color: #fff;font-size: .16rem}
  .navli .pa{font-size:0.36rem;color: #fff;left:50%;top: .18rem;margin-left: -.2rem;}
  .header-nav ul li.libg{
    background: -webkit-linear-gradient(#05459c, #012352);
    background: -o-linear-gradient(#05459c, #012352);
    background: -moz-linear-gradient(#05459c, #012352);
    background: linear-gradient(#05459c, #012352);
    height:.9rem;
    border-top: solid 0.04rem #ffd452;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavHeader.vue